import React, {useState, useEffect} from 'react';
import Icon from '@Components/Icon';

const Toast = ({message, fillColor = 'fill--off-white-alpha-50', show, onClose}) => {
  const [active, setActive] = useState(show);

  useEffect(() => {
    setActive(show);
  }, [show]);

  const messageCapitalized = message ? message.charAt(0).toUpperCase() + message.slice(1) : '';

  return (
    <div
      className={`toast bg-variant-brand-secondary ${active ? 'show toast--active' : 'closable--closed'}`}
      data-rs-toast="3"
      data-rs-toast-3=""
    >
      <p className="toast__message">{messageCapitalized}</p>
      <button
        className="button--icon-only"
        onClick={() => onClose()}
      >
        <span className={`icon ${fillColor}`}>
          <Icon type="close" />
        </span>
      </button>
    </div>
  );
};

export default Toast;
